import React, {useMemo} from 'react';
import styled from "styled-components";
import SmallInfluInfo from "../../common/SmallInfluInfo";
import ToSummonerLink from "../../Link/ToSummonerLink";

const Wrapper = styled.div`
  width: 376px;
  border-left: 1px solid ${props => props.theme.color.green_100};
  border-top: 6px solid ${props => props.theme.color.green_100};
  border-bottom: 1px solid ${props => props.theme.color.green_100};
  border-right: 1px solid ${props => props.theme.color.green_100};
  border-radius: 6px;
`;

const Header = styled.div`
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.color.site_main_color};
  gap: 16px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16.5px;
  gap: 16px;
`;
const HeaderText = styled.span`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 100%;
  text-align: center;
`;

const HeaderGreenText = styled.span`
  color: ${props => props.theme.color.green_100};
`;

const QuestionBox = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: center;

  color: ${props => props.theme.color.green_100};
`;

const SllTierRunAward = ({awardData}) => {

    return (
        <Wrapper>
            <Header>
                <div>
                    <img src={`images/sll/icon_sll_trophy.png`} alt={''} width={22} height={22}/>
                </div>
                <div>
                    <HeaderText>
                        <HeaderGreenText>실시간</HeaderGreenText> AWARD
                    </HeaderText>
                </div>
                <div>
                    <img src={`images/sll/icon_sll_trophy.png`} alt={''} width={22} height={22}/>
                </div>
            </Header>
            <Content>
                <SllTierRunAwardCard Header={
                    <CardHeader>
                        <img src={`images/sll/icon_exclude.svg`} alt={''} width={16} height={20}/>
                        <CardHeaderText>빤짝이 상</CardHeaderText>
                        <img src={`images/sll/icon_exclude.svg`} alt={''} width={16} height={20}/>
                    </CardHeader>
                }
                                     explain={'티어런 진행 기간 중 최다 빤짝이를 달성한 참가자'}
                                     list={awardData.exclude}
                />
                <SllTierRunAwardCard Header={
                    <CardHeader>
                        <img src={`images/sll/icon_bounce.svg`} alt={''} width={24} height={24}/>
                        <CardHeaderText>팀운 불쌍</CardHeaderText>
                        <img src={`images/sll/icon_bounce.svg`} alt={''} width={24} height={24}/>
                    </CardHeader>
                }
                                     explain={'티어런 진행 기간 중 불리한 팀운으로 가장 많이 고통받은 참가자'}
                                     list={awardData.badLuck}
                />
                <SllTierRunAwardCard
                    Header={
                        <CardHeader>
                            <QuestionBox>?</QuestionBox>
                            <CardHeaderText>히든상</CardHeaderText>
                            <QuestionBox>?</QuestionBox>
                        </CardHeader>
                    }
                    explain={'티어런 진행 기간 중 딥롤 선정 히든 미션을 가장 많이 달성한 참가자'}
                    list={awardData.hidden}
                />

                <a href={'https://brand.naver.com/razerplace/products/12148923940'} id={'add_to_Banner_3'}
                   target={'_blank'}>
                    <img src={'./images/ad/ad_tier_run.png'} width={'100%'} alt={''}/>
                </a>
            </Content>
        </Wrapper>
    );
};

const SllTierRunAwardCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 205px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 16px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 6px;
`;
const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  height: 32px;
`;

const CardHeaderText = styled.span`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: ${props => props.theme.color.dark_100};

  &:hover {
    text-decoration: underline;
  }
`;

const CardHeaderSubText = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  line-height: 125%;
  color: ${props => props.theme.color.dark_200};
`;

const TierRunAwardCardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 118px;
  margin-top: 16px;
`;

const Circle = styled.div`
  opacity: ${props => props.opacity};
  z-index: 2;
  margin-left: 2px;
  box-sizing: content-box;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: 5px solid ${props => props.theme.color.green_100};
  border-radius: 100%;
`;
const ContentItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const NameBox = styled.div`
  opacity: ${props => props.opacity};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 14px;
  width: 222px;
  height: 18px;
`;
const ProNameBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const CountText = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.dark_100};
`;
const FlameEmptyBox = styled.div`
  width: 18px;
  height: 18px;
`;

const Dash = styled.div`
  width: 1px;
  background: repeating-linear-gradient(to bottom, ${props => props.theme.color.dark_200} 0 4px, transparent 4px 8px);
  opacity: 1;
  height: 49px;
`;
const BottomDash = styled.div`
  width: 1px;
  background: repeating-linear-gradient(to bottom, ${props => props.theme.color.dark_300} 0 4px, transparent 4px 8px);
  opacity: 1;
  height: 30px;
`;


const BottomAbsoluteBox = styled.div`
  position: absolute;
  left: 28.5px;
  bottom: 17px;
`;

const AbsoluteBox = styled.div`
  top: 0;
  left: 28.5px;
  position: absolute;
  z-index: 0;
`;


const CircleBox = styled.div`
  width: 18px;
  height: 18px;
  position: relative;
`;

const SllTierRunAwardCard = ({Header, explain, list}) => {
    const first = useMemo(() => {
        try {
            return {
                name: list[0].name,
                count: list[0].times,
                status: list[0].status,
                riot_id_name: list[0].riot_id_name,
                riot_id_tag_line: list[0].riot_id_tag_line,
                puu_id: list[0].puu_id,
            }
        } catch (e) {
            return {name: "", count: 0, status: ""}
        }
    }, [list]);

    const second = useMemo(() => {
        try {
            return {
                name: list[1].name, count: list[1].times, status: list[1].status,
                riot_id_name: list[1].riot_id_name,
                riot_id_tag_line: list[1].riot_id_tag_line,
                puu_id: list[1].puu_id,
            }
        } catch (e) {
            return {name: "", count: 0, status: ""}
        }
    }, [list]);

    const third = useMemo(() => {
        try {
            return {
                name: list[2].name, count: list[2].times, status: list[2].status,
                riot_id_name: list[2].riot_id_name,
                riot_id_tag_line: list[2].riot_id_tag_line,
                puu_id: list[2].puu_id,
            }
        } catch (e) {
            return {
                name: "", count: 0, status: "",
                riot_id_name: "",
                riot_id_tag_line: '',
                puu_id: "",
            }
        }
    }, [list]);

    return (
        <SllTierRunAwardCardWrapper>
            {Header}

            <div>
                <CardHeaderSubText>
                    {explain}
                </CardHeaderSubText>
            </div>
            <TierRunAwardCardContent>
                <AbsoluteBox>
                    <Dash/>
                </AbsoluteBox>
                <BottomAbsoluteBox>
                    <BottomDash/>
                </BottomAbsoluteBox>
                <ContentItem>
                    <img src={`images/sll/icon_flame.svg`} alt={''} width={18} height={18}/>
                    <CircleBox>
                        <Circle opacity={'1'}/>

                    </CircleBox>
                    <NameBox opacity={'1'}>
                        <ToSummonerLink name={`${first.riot_id_name}-${first.riot_id_tag_line}`} region={'KR'}>
                            <ProNameBox>
                                <SmallInfluInfo height={16} width={16} status={first.status}/>
                                <CardHeaderText>{first.name}</CardHeaderText>
                            </ProNameBox>
                        </ToSummonerLink>
                        <div>
                            <CountText>
                                {first.count} 회
                            </CountText>
                        </div>
                    </NameBox>
                </ContentItem>
                <ContentItem>
                    <FlameEmptyBox/>
                    <Circle opacity={'0.7'}/>
                    <NameBox opacity={'0.8'}>
                        <ToSummonerLink name={`${second.riot_id_name}-${second.riot_id_tag_line}`} region={'KR'}>
                            <ProNameBox>
                                <SmallInfluInfo height={16} width={16} status={second.status}/>
                                <CardHeaderText>{second.name}</CardHeaderText>
                            </ProNameBox>
                        </ToSummonerLink>
                        <div>
                            <CountText>
                                {second.count} 회
                            </CountText>
                        </div>
                    </NameBox>
                </ContentItem>
                <ContentItem>
                    <FlameEmptyBox/>
                    <Circle opacity={'0.3'}/>
                    <NameBox opacity={'0.6'}>
                        <ToSummonerLink name={`${third.riot_id_name}-${third.riot_id_tag_line}`} region={'KR'}>
                            <ProNameBox>
                                <SmallInfluInfo height={16} width={16} status={third.status}/>
                                <CardHeaderText>{third.name}</CardHeaderText>
                            </ProNameBox>
                        </ToSummonerLink>
                        <div>
                            <CountText>
                                {third.count} 회
                            </CountText>
                        </div>
                    </NameBox>
                </ContentItem>
            </TierRunAwardCardContent>

        </SllTierRunAwardCardWrapper>
    )
}

export default SllTierRunAward;